<div class="indication-buttons" [class.indication-buttons--no-outer-margin]="omitIndicationRowMargin">
	<div class="indication-buttons__group">
		<rx-intuitive-art-indication-button
			*ngFor="let integrity of visibleIntegrities; trackBy: integrityTrackBy"
			[indication]="integrity"
			[isActive]="selectedIntegrity === integrity"
			[disabled]="isIntegrityDisabled(integrity)"
			[hideIcon]="hideIcon"
			[asLabel]="asLabel"
			(clicked)="onIntegrityClicked($event)"
		/>
	</div>
	<div class="indication-buttons__group">
		<rx-intuitive-art-indication-button
			*ngFor="let definition of visibleDefinitions; trackBy: definitionTrackBy"
			[indication]="definition"
			[isActive]="selectedDefinitions.includes(definition)"
			[disabled]="isDefinitionDisabled(definition)"
			[hideIcon]="hideIcon"
			[asLabel]="asLabel"
			(clicked)="onDefinitionClicked($event)"
		/>
	</div>
	<ng-content></ng-content>
</div>
